import { localStore } from "@/lib/webStorage";

export type BookingsViewMode = "list" | "calendar";

const STORAGE_KEY = "flitrip.bookings.preferredView";

const VALID_MODES: ReadonlySet<BookingsViewMode> = new Set([
  "list",
  "calendar",
]);

export function readBookingsViewPreference(): BookingsViewMode | null {
  const raw = localStore.getItem(STORAGE_KEY);
  if (raw === "grid") {
    return "list";
  }
  if (raw && VALID_MODES.has(raw as BookingsViewMode)) {
    return raw as BookingsViewMode;
  }
  return null;
}

export function writeBookingsViewPreference(mode: BookingsViewMode): void {
  localStore.setItem(STORAGE_KEY, mode);
}

export function parseBookingsViewMode(param: string | null): BookingsViewMode {
  if (param === "calendar") return "calendar";
  return "list";
}
